export const CREATE_TIMELOG_MODAL_ID = 'create-timelog-modal';
export const SET_TIME_ESTIMATE_MODAL_ID = 'set-time-estimate-modal';
